export default __webpack_public_path__ + "static/media/HARYANA-6.d2c6d97d.webp";